/** D-ID Agent ID for real-time avatar (from D-ID Studio or List Agents API) */

/** FFT size for Web Audio analyser (frequency bin count = fftSize / 2) */
export const ANALYSER_FFT_SIZE = 512;

/** Buffer size for ScriptProcessorNode (samples per processing block) */
export const SCRIPT_PROCESSOR_BUFFER_SIZE = 4096;

// ======================
// CHROMA KEY (green screen)
// ======================

/** Minimum green channel value to consider pixel as green */
export const CHROMA_MIN_GREEN = 80;

/** Green must be this many times greater than R and B to count as green */
export const CHROMA_DOMINANCE = 1.35;

/** Softness factor for alpha blend at green-screen edges */
export const CHROMA_SOFTNESS = 40;

// ======================
// SILENCE DETECTION
// ======================

/** Below this = silence/noise (start 3s countdown). Above SPEECH_* = user talking (cancel countdown). */
export const SILENCE_THRESHOLD_START_MIC = 15;
export const SILENCE_THRESHOLD_TOGGLE_MIC = 15;

/** Above this = user is talking (resets silence timer). Keeps ambient noise from cancelling. */
export const SPEECH_THRESHOLD_START_MIC = 28;
export const SPEECH_THRESHOLD_TOGGLE_MIC = 28;

/** How long silence/noise must last (ms) after user stopped talking before auto-stopping mic */
export const SILENCE_DURATION_MS = 700;

// ======================
// AVATAR PLAYBACK
// ======================

/**
 * Extra time (ms) to keep the WebRTC video playing after the server sends
 * stream/done. The signal arrives before the browser finishes buffered audio.
 */
export const STREAM_DONE_PLAYBACK_TAIL_MS = 900;

// ======================
// EXPORTS
// ======================

const realTimeAvatarConfig = {
  ANALYSER_FFT_SIZE,
  SCRIPT_PROCESSOR_BUFFER_SIZE,
  CHROMA_MIN_GREEN,
  CHROMA_DOMINANCE,
  CHROMA_SOFTNESS,
  SILENCE_THRESHOLD_START_MIC,
  SILENCE_THRESHOLD_TOGGLE_MIC,
  SPEECH_THRESHOLD_START_MIC,
  SPEECH_THRESHOLD_TOGGLE_MIC,
  SILENCE_DURATION_MS,
  STREAM_DONE_PLAYBACK_TAIL_MS,
};

export default realTimeAvatarConfig;
